<template>
  <div class="vtitle" v-show="0 < title2.length">
    <!-- <span class="title"><b-icon icon="flower3"></b-icon>{{pageTitle}}</span> -->
    <b-breadcrumb style="margin-bottom: 0.125rem;">
      <b-breadcrumb-item href="#" @click="home()">
        <b-icon icon="house-fill" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
        首頁
      </b-breadcrumb-item>
      <b-breadcrumb-item active>{{title1}}</b-breadcrumb-item>
      <b-breadcrumb-item active>{{title2}}</b-breadcrumb-item>
    </b-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'vtitle',
  props: [
    'pageInfo', 'curLang'
  ],
  computed: {
    title1: function () {
      var ret = '';
      if ((this.pageInfo != null) && (this.$store.getters.getAppId > -1) && (this.$store.getters.getPageId > -1)) {
        var appId = this.$store.getters.getAppId
        var pageId = this.$store.getters.getPageId
        //url = this.pageInfo[0].subMenu[appId].subMenu[pageId].title[this.curLang]
        ret = this.pageInfo[0].subMenu[appId].title[this.curLang];
      }
      return ret
    },
    title2: function () {
      var ret = '';
      if ((this.pageInfo != null) && (this.$store.getters.getAppId > -1) && (this.$store.getters.getPageId > -1)) {
        var appId = this.$store.getters.getAppId
        var pageId = this.$store.getters.getPageId
        //url = this.pageInfo[0].subMenu[appId].subMenu[pageId].title[this.curLang]
        ret = this.pageInfo[0].subMenu[appId].subMenu[pageId].title[this.curLang];
      }
      return ret
    }
  },
  methods: {
    home: function() {
      this.$emit('toggle', -1, -1)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vtitle {
  text-align: left;
  padding: 0.5rem;
}
.title {
    color: #144a74;
    font-size: x-large;
    font-weight: bold;
    min-height: 20px;
    padding: 0.1em 0.2em; 
    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.05);
    box-shadow: inset 0 1px 1px rgba(0,0,0,.05);
}
</style>
